import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  inject,
} from '@angular/core';

/**
 * Emits if the user clicks outside the host element.
 */
@Directive({
  selector: `
   [flOutsideClick],
  `,
  standalone: true,
})
export class OutsideClickDirective {
  private elementRef = inject(ElementRef);

  @Output()
  outsideClick: EventEmitter<MouseEvent> = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.outsideClick.emit(event);
    }
  }
}
